import React from "react";
import { formatDisplayDateTime } from "../common/dateFormat";

/** Format API ISO date/datetime for display */
export function formatRecordDate(iso) {
  if (iso == null || iso === "") return null;
  try {
    const formatted = formatDisplayDateTime(iso);
    return formatted || String(iso);
  } catch {
    return String(iso);
  }
}

/**
 * Read-only creator + creation time (from record_creator / record_created_at on API).
 */
export default function RecordAuditBlock({ creator, createdAt, style }) {
  const when = formatRecordDate(createdAt);
  return (
    <div
      style={{
        fontSize: "0.88em",
        color: "#495057",
        marginBottom: "1rem",
        padding: "10px 14px",
        background: "#f8f9fa",
        borderRadius: "8px",
        borderLeft: "3px solid #93ab3c",
        ...style,
      }}
    >
      <div style={{ fontSize: "0.72em", textTransform: "uppercase", letterSpacing: "0.06em", color: "#868e96" }}>
        Created by
      </div>
      <div style={{ fontWeight: 600, color: "#212529", marginTop: "2px" }}>{creator || "—"}</div>
      {when ? (
        <>
          <div style={{ fontSize: "0.72em", textTransform: "uppercase", letterSpacing: "0.06em", color: "#868e96", marginTop: "8px" }}>
            Created
          </div>
          <div style={{ marginTop: "2px" }}>{when}</div>
        </>
      ) : null}
    </div>
  );
}
